import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'contexts/auth.context';
import iotApi from 'lib/api/iotApi.client';
import {
  GetOrderDetailsByIdParams,
  GetOrdersByTypeAndStatusParams,
} from 'lib/api/requests/order/order.requests.types';
import { UserRole } from 'types/shared';
import { OrderQueryKey } from './order.hooks.keys';

export function useGetOrdersByTypeAndStatus(
  params: GetOrdersByTypeAndStatusParams
) {
  return useQuery({
    queryKey: [OrderQueryKey.GetOrdersByTypeAndStatus, params],
    queryFn: async () => {
      const res = await iotApi.order.getOrdersByTypeAndStatus(params);

      return res;
    },
  });
}

export function useGetOrderDetailsById(params: GetOrderDetailsByIdParams) {
  const { user } = useAuthContext();

  return useQuery({
    queryKey: [OrderQueryKey.GetOrderDetailsById, params],
    queryFn: async () => {
      const res = await iotApi.order.getOrderDetailsById(params);

      return res;
    },
    // do not fetch order details if user role is 'user'
    enabled: user?.role !== UserRole.USER,
    keepPreviousData: true,
  });
}
